import * as FiIcons from 'react-icons/fi';
import { useGoogleAuth } from '@questlabs/auth-js';
import SafeIcon from '../common/SafeIcon';

const { FiFilm, FiLogOut, FiDownload, FiUpload } = FiIcons;

export default function Header({ user, onExport, onImport }) {
  const { signOut } = useGoogleAuth();

  return (
    <header className="app-header">
      <div className="brand">
        <SafeIcon icon={FiFilm} />
        <div>
          <strong>SceneFlow</strong>
          <span>SANS TITRE</span>
        </div>
      </div>
      <div className="header-actions">
        <button className="quiet-button" onClick={onImport}>
          <SafeIcon icon={FiUpload} /> Import
        </button>
        <button className="quiet-button" onClick={onExport}>
          <SafeIcon icon={FiDownload} /> Export
        </button>
        <div className="account">
          {user.picture && <img src={user.picture} alt="" />}
          <span>{user.name || user.email}</span>
          <button aria-label="Sign out" onClick={signOut}>
            <SafeIcon icon={FiLogOut} />
          </button>
        </div>
      </div>
    </header>
  );
}